import { render, staticRenderFns } from "./IndustryTable.vue?vue&type=template&id=54ad110f&scoped=true&"
import script from "./IndustryTable.vue?vue&type=script&lang=js&"
export * from "./IndustryTable.vue?vue&type=script&lang=js&"
import style0 from "./IndustryTable.vue?vue&type=style&index=0&id=54ad110f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ad110f",
  null
  
)

export default component.exports